// src/utils/tokenExpiredNotification.js

// 토큰 만료 알림을 보여주는 함수
export const showTokenExpiredNotification = () => {
  // 이미 알림이 표시되고 있다면 중복 방지
  if (document.querySelector('.token-expired-notification')) {
    return;
  }

  // 알림 컨테이너 생성
  const notification = document.createElement('div');
  notification.className = 'token-expired-notification';
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #ff6b6b, #ee5a24);
    color: white;
    padding: 20px 24px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    z-index: 10000;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    min-width: 300px;
    max-width: 400px;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  `;

  // 알림 내용 (DOM API로 안전하게 생성)
  const container = document.createElement('div');
  container.style.cssText = 'display: flex; align-items: flex-start; gap: 12px;';

  const lockIcon = document.createElement('div');
  lockIcon.style.cssText = 'font-size: 24px; flex-shrink: 0;';
  lockIcon.textContent = '\uD83D\uDD12';

  const textBlock = document.createElement('div');
  textBlock.style.flex = '1';

  const title = document.createElement('div');
  title.style.cssText = 'font-weight: 600; margin-bottom: 8px; font-size: 16px;';
  title.textContent = '로그인 토큰이 만료되었습니다';

  const subtitle = document.createElement('div');
  subtitle.style.cssText = 'opacity: 0.9; margin-bottom: 12px;';
  subtitle.textContent = '보안을 위해 다시 로그인해주세요.';

  const countdown = document.createElement('div');
  countdown.style.cssText = 'font-size: 12px; opacity: 0.8;';
  countdown.textContent = '3초 후 자동으로 로그인 페이지로 이동합니다...';

  textBlock.append(title, subtitle, countdown);

  const closeBtn = document.createElement('button');
  closeBtn.textContent = '\u2715';
  closeBtn.style.cssText = 'background: none; border: none; color: white; font-size: 18px; cursor: pointer; opacity: 0.7; padding: 0; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; border-radius: 4px; transition: opacity 0.2s;';
  closeBtn.addEventListener('mouseenter', () => { closeBtn.style.opacity = '1'; });
  closeBtn.addEventListener('mouseleave', () => { closeBtn.style.opacity = '0.7'; });
  closeBtn.addEventListener('click', () => { notification.remove(); });

  container.append(lockIcon, textBlock, closeBtn);
  notification.appendChild(container);

  // DOM에 추가
  document.body.appendChild(notification);

  // 애니메이션으로 슬라이드 인
  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
  }, 100);

  // 3초 후 자동으로 로그인 페이지로 이동
  setTimeout(() => {
    // 슬라이드 아웃 애니메이션
    notification.style.transform = 'translateX(100%)';
    
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
      window.location.href = '/admin/login';
    }, 300);
  }, 3000);

  // 클릭 시 즉시 로그인 페이지로 이동
  notification.addEventListener('click', (e) => {
    if (e.target.tagName !== 'BUTTON') {
      window.location.href = '/admin/login';
    }
  });
};

// 토큰 만료 처리 함수 (기존 handleTokenExpiry 대체용)
export const handleTokenExpiry = async () => {
  // 서버에 로그아웃 요청 (httpOnly 쿠키 삭제)
  try {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
    await fetch(`${apiBaseUrl}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // 로그아웃 API 실패해도 계속 진행
  }
  localStorage.removeItem('csrf_token');

  // 토큰 만료 알림 표시
  showTokenExpiredNotification();
}; 